import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "overview-section" }
const _hoisted_6 = { class: "custom-section" }
const _hoisted_7 = { class: "custom-section__filter" }
const _hoisted_8 = { class: "custom-section__display" }
const _hoisted_9 = { class: "selector" }
const _hoisted_10 = { class: "month-selector" }
const _hoisted_11 = { class: "month-selector__text" }
const _hoisted_12 = { class: "month-selector__selector" }
const _hoisted_13 = {
  key: 0,
  class: "period-selector"
}
const _hoisted_14 = { class: "period-selector__text" }
const _hoisted_15 = {
  key: 0,
  class: "default-view"
}
const _hoisted_16 = { class: "default-view__icon-bg" }
const _hoisted_17 = { class: "default-view__text" }
const _hoisted_18 = { class: "default-view__text--title" }
const _hoisted_19 = { class: "default-view__text--desc" }

import { i18n } from '@/i18n';
import OverviewSectionCard from '../components/OverviewSectionCard.vue';
import { DASHBOARD_GENERAL_SECTION_ITEM, FILTER_OPTIONS, INVENTORY_DASHBOARD_PATH } from '../constants';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import SegmentControl from '@/corePagesModule/components/SegmentControl.vue';
import { computed, onMounted } from 'vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import ListViewSection from '../components/ListViewSection.vue';
import { storeToRefs } from 'pinia';
import { useInventoryDashboardStore } from './useInventoryDashboardStore';
import { ViewType } from './useInventoryDashboardStore/types';
import { InventoryDashboardViewModel } from './inventoryDashboardViewModel';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useRouter } from 'vue-router';
import GraphViewSection from '../components/GraphViewSection.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import EzTableLoadingState from '@/corePagesModule/components/ezTable/EzTableLoadingState.vue';
import EzTableErrorState from '@/corePagesModule/components/ezTable/EzTableErrorState.vue';
import { MetricTypes } from '../domains/entities/Dashboard';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';

// index

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

_useCssVars(_ctx => ({
  "c8fb1c3c": (_unref(DASHBOARD_GENERAL_SECTION_ITEM).length)
}))

const t = i18n.t;
const router = useRouter();

const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const {
  changeDisplayYearMonth,
  changeDisplayYearMonthPeriod,
  changeForecastAccuracyPeriod,
  changeDimensionType,
  changeMetricType,
  getOverviewData,
  getByDimensionData,
} = store;
const vm = new InventoryDashboardViewModel();

const isInformationNotSelected = computed(() => vm.isDisplayDefaultView(state.value.information));
const locale = computed(() => i18n.locale);

/**
 * KPI設定ボタン押下時ハンドラ
 */
const HandleOnClickKpiSetting = () => {
  router.push(`${INVENTORY_DASHBOARD_PATH}/setting/kpi`);
};

/**
 * フィルター適用時のハンドラ
 * @param changedFilterItems - 変更したフィルタ情報
 */
const onApplyFilterHandler = async (changedFilterItems: FilterContentItem[]) => {
  state.value.filterItems = [...changedFilterItems];
  await getByDimensionData();
};

/**
 * ページタイプを変更した際の処理
 * @param value - 変更後のページタイプ
 */
const onChangeViewSegment = (value: ViewType) => {
  state.value.checkedBusinessId = [];
  state.value.nowViewType = value;
};

onMounted(async () => {
  state.value.checkedBusinessId = [];
  await waitLoading(getOverviewData(), undefined, '');
  await getByDimensionData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('ダッシュボード')), 1),
      _createVNode(TextButton, {
        size: "btn-sm",
        onClick: HandleOnClickKpiSetting
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('KPI設定')), 1)
        ], undefined, true),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DASHBOARD_GENERAL_SECTION_ITEM), (item) => {
          return (_openBlock(), _createBlock(OverviewSectionCard, {
            key: item.label,
            item: item
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(SelectInput, {
            index: 0,
            "model-value": _unref(t)(_unref(vm).dimensionTypesMapper[_unref(state).information.dimensionType] ?? ''),
            placeholder: _unref(t)('選択してください'),
            "filter-type": "INVENTORY_DASHBOARD_DISPLAY_DATA_TYPE",
            "prop-options": _unref(vm).getDimensionTypesDisplayValue(),
            "use-search-input": false,
            "use-reset": false,
            label: _unref(t)('表示項目'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _unref(changeDimensionType)(_unref(vm).convertDisplayValueToDimensionType(value)))
          }, null, 8, ["model-value", "placeholder", "prop-options", "label"]),
          _createVNode(SelectInput, {
            index: 1,
            "model-value": _unref(t)(_unref(vm).metricTypesMapper[_unref(state).information.metricType] ?? ''),
            placeholder: _unref(t)('選択してください'),
            "filter-type": "INVENTORY_DASHBOARD_DISPLAY_DATA_COLUMN",
            "prop-options": _unref(vm).getMetricTypesDisplayValue(),
            "use-search-input": false,
            "use-reset": false,
            label: _unref(t)('表示データ'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _unref(changeMetricType)(_unref(vm).convertDisplayValueToMetricType(value)))
          }, null, 8, ["model-value", "placeholder", "prop-options", "label"]),
          _createVNode(SelectInput, {
            index: 2,
            "model-value": _unref(vm).convertNumberToDisplayForecastAccuracyPeriod(_unref(state).forecastAccuracyPeriod),
            placeholder: _unref(t)('選択してください'),
            "prop-options": _unref(FILTER_OPTIONS).ANNOUNCE_ACCURACY.map((option) => _unref(t)(option)),
            "filter-type": "INVENTORY_DASHBOARD_ANNOUNCE_ACCURACY",
            "use-search-input": false,
            "use-reset": true,
            label: _unref(t)('考慮する内示正答率期間'),
            disabled: _unref(state).information.metricType !== _unref(MetricTypes).Turnover,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => _unref(changeForecastAccuracyPeriod)(_unref(vm).convertDisplayForecastAccuracyPeriodToNumber(value)))
          }, null, 8, ["model-value", "placeholder", "prop-options", "label", "disabled"]),
          _createVNode(FilterModalButton, {
            "filter-modal-type": "inventoryDashboard",
            "select-input-index": 10,
            onApply: onApplyFilterHandler
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('表示月')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(MonthPicker, {
                  class: "month-selector__input",
                  locale: locale.value,
                  "prop-format": _unref(t)('MonthPickerFormat'),
                  "model-value": _unref(state).displayYearMonth,
                  "onUpdate:modelValue": _unref(changeDisplayYearMonth)
                }, null, 8, ["locale", "prop-format", "model-value", "onUpdate:modelValue"]),
                _createVNode(Mdi, {
                  class: "month-selector__icon",
                  icon: "calendar_today"
                })
              ])
            ]),
            (_unref(state).nowViewType === _unref(ViewType).Graph)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('表示期間')), 1),
                  _createVNode(MonthPicker, {
                    class: "period-selector__input",
                    locale: locale.value,
                    "prop-format": _unref(t)('MonthPickerFormat'),
                    "max-date": 
                  _unref(DateService).getShiftedIYearMonthByMonths(_unref(state).displayYearMonthPeriod[1].year, _unref(state).displayYearMonthPeriod[1].month, -1)
                ,
                    "model-value": _unref(state).displayYearMonthPeriod[0],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = (e) => _unref(changeDisplayYearMonthPeriod)([e, undefined]))
                  }, null, 8, ["locale", "prop-format", "max-date", "model-value"]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "period-selector__text period-selector__text--line" }, "~", -1)),
                  _createVNode(MonthPicker, {
                    class: "period-selector__input",
                    locale: locale.value,
                    "prop-format": _unref(t)('MonthPickerFormat'),
                    "min-date": 
                  _unref(DateService).getShiftedIYearMonthByMonths(_unref(state).displayYearMonthPeriod[0].year, _unref(state).displayYearMonthPeriod[0].month, 1)
                ,
                    "model-value": _unref(state).displayYearMonthPeriod[1],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = (e) => _unref(changeDisplayYearMonthPeriod)([undefined, e]))
                  }, null, 8, ["locale", "prop-format", "min-date", "model-value"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(SegmentControl, {
            "model-value": _unref(state).nowViewType,
            "value-a": _unref(ViewType).Graph,
            "value-b": _unref(ViewType).List,
            "label-a": _unref(t)('月次推移表示'),
            "label-b": _unref(t)('リスト表示'),
            "aria-label": "表示切り替え",
            name: "change-view",
            "onUpdate:modelValue": onChangeViewSegment
          }, null, 8, ["model-value", "value-a", "value-b", "label-a", "label-b"])
        ]),
        (isInformationNotSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Mdi, {
                  icon: "assessment",
                  variant: "outlined",
                  class: "default-view__icon"
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('在庫管理ダッシュボード')), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('表示項目、表示データ、表示月を選択して、設定したKPI達成率の確認や月次推移などのデータを可視化できます。')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(state).informationLoadingState.status.type === 'loading')
                ? (_openBlock(), _createBlock(EzTableLoadingState, {
                    key: 0,
                    message: _unref(t)('データを読み込んでいます')
                  }, null, 8, ["message"]))
                : (_unref(state).informationLoadingState.status.type === 'success')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _withDirectives(_createVNode(ListViewSection, null, null, 512), [
                        [_vShow, _unref(state).nowViewType === _unref(ViewType).List]
                      ]),
                      _withDirectives(_createVNode(GraphViewSection, null, null, 512), [
                        [_vShow, _unref(state).nowViewType === _unref(ViewType).Graph]
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock(EzTableErrorState, {
                      key: 2,
                      onRetry: _unref(getByDimensionData)
                    }, null, 8, ["onRetry"]))
            ], 64))
      ])
    ])
  ]))
}
}

})